export default __webpack_public_path__ + "static/board-template2-9c6d7864b5199459b31e71ab8f2be27d.png";